import React from 'react';
import PropTypes from 'prop-types';
import { Menu, Dropdown, Icon, Button } from 'antd';
import { Switch, Route } from 'react-router-dom';
import Link from '../components/general/Link';
import Logo from '../img/logo.png';
import RetainerLayout from './RetainerLayout';
import EducationLoansLayout from './EducationLoansLayout';

const menu = (
  <Menu>
    <Menu.Item>Logout</Menu.Item>
  </Menu>
);

const AppLayout = ({ user }) => (
  <div>
    <div className="header">
      <Link to="/">
        <img src={Logo} alt="Logo" />
      </Link>
      <Dropdown overlay={menu} trigger={['click']}>
        <a className="ant-dropdown-link" href="#">
          {user} <Icon type="down" />
        </a>
      </Dropdown>
    </div>

    <Switch>
      <Route path="/retainer" component={RetainerLayout} />
      <Route path="/edl" component={EducationLoansLayout} />
      <Route
        render={() => (
          <div style={{ padding: 20 }}>
            <Link to="/retainer">
              <Button htmlType="button">Retainer</Button>
            </Link>
            <Link to="/edl">
              <Button htmlType="button" style={{ marginLeft: 15 }}>
                Education Loans
              </Button>
            </Link>
          </div>
        )}
      />
    </Switch>
  </div>
);

AppLayout.propTypes = {
  user: PropTypes.string.isRequired,
};

export default AppLayout;



// WEBPACK FOOTER //
// ./src/layouts/AppLayout.jsx